import React from 'react';

// Employee Modal
export const EmployeeModal = ({
  show,
  onClose,
  mode,
  form,
  setForm,
  roles,
  loading,
  onCreate,
  onUpdate
}) => {
  if (!show) return null;

  const allDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{mode === 'create' ? 'Add Employee' : 'Edit Employee'}</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label>Name *</label>
            <input
              type="text"
              value={form.name}
              onChange={e => setForm({ ...form, name: e.target.value })}
              placeholder="Full name"
            />
          </div>
          <div className="form-group">
            <label>Email *</label>
            <input
              type="email"
              value={form.email}
              onChange={e => setForm({ ...form, email: e.target.value })}
              placeholder="employee@email.com"
            />
            {mode === 'create' && (
              <small>A temporary password will be generated for the employee</small>
            )}
          </div>
          <div className="form-group">
            <label>Phone</label>
            <input
              type="tel"
              value={form.phone}
              onChange={e => setForm({ ...form, phone: e.target.value })}
              placeholder="(555) 123-4567"
            />
          </div>
          <div className="form-group">
            <label>Roles</label>
            <div className="checkbox-group horizontal">
              {roles.map(role => (
                <label key={role.role_id} className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={form.role_ids.includes(role.role_id)}
                    onChange={e => {
                      if (e.target.checked) {
                        setForm({ ...form, role_ids: [...form.role_ids, role.role_id] });
                      } else {
                        setForm({ ...form, role_ids: form.role_ids.filter(id => id !== role.role_id) });
                      }
                    }}
                  />
                  {role.name}
                </label>
              ))}
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button
            className="btn btn-primary"
            onClick={mode === 'create' ? onCreate : onUpdate}
            disabled={loading || !form.name || !form.email}
          >
            {loading ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

// Role Modal
export const RoleModal = ({
  show,
  onClose,
  mode,
  form,
  setForm,
  loading,
  onCreate,
  onUpdate
}) => {
  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{mode === 'create' ? 'Add Role' : 'Edit Role'}</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label>Role Name *</label>
            <input
              type="text"
              value={form.name}
              onChange={e => setForm({ ...form, name: e.target.value })}
              placeholder="e.g., Server, Bartender, Host"
            />
          </div>
          <div className="form-group">
            <label>Target Per Hour (TPH)</label>
            <input
              type="number"
              value={form.tph}
              onChange={e => setForm({ ...form, tph: e.target.value })}
              placeholder="e.g., 2"
            />
            <small>Number of this role needed per hour during peak times</small>
          </div>
          <div className="form-group">
            <label>Description</label>
            <textarea
              value={form.description}
              onChange={e => setForm({ ...form, description: e.target.value })}
              placeholder="Brief description of responsibilities"
            />
          </div>
          <div className="form-group">
            <label>Color</label>
            <input
              type="color"
              value={form.color}
              onChange={e => setForm({ ...form, color: e.target.value })}
            />
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button
            className="btn btn-primary"
            onClick={mode === 'create' ? onCreate : onUpdate}
            disabled={loading || !form.name}
          >
            {loading ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

// Shift Modal
export const ShiftModal = ({
  show,
  onClose,
  mode,
  form,
  setForm,
  loading,
  onCreate,
  onUpdate
}) => {
  if (!show) return null;

  const allDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{mode === 'create' ? 'Add Shift' : 'Edit Shift'}</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label>Shift Name *</label>
            <input
              type="text"
              value={form.name}
              onChange={e => setForm({ ...form, name: e.target.value })}
              placeholder="e.g., Morning, Evening, Weekend"
            />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Start Time *</label>
              <input
                type="time"
                value={form.start_time}
                onChange={e => setForm({ ...form, start_time: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>End Time *</label>
              <input
                type="time"
                value={form.end_time}
                onChange={e => setForm({ ...form, end_time: e.target.value })}
              />
            </div>
          </div>
          <div className="form-group">
            <label>Color</label>
            <input
              type="color"
              value={form.color}
              onChange={e => setForm({ ...form, color: e.target.value })}
            />
          </div>
          <div className="form-group">
            <label>Days of Week</label>
            <div className="checkbox-group horizontal">
              {allDays.map(day => (
                <label key={day} className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={form.days_of_week.includes(day)}
                    onChange={e => {
                      if (e.target.checked) {
                        setForm({ ...form, days_of_week: [...form.days_of_week, day] });
                      } else {
                        setForm({ ...form, days_of_week: form.days_of_week.filter(d => d !== day) });
                      }
                    }}
                  />
                  {day.substring(0, 3).toUpperCase()}
                </label>
              ))}
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button
            className="btn btn-primary"
            onClick={mode === 'create' ? onCreate : onUpdate}
            disabled={loading || !form.name || !form.start_time || !form.end_time}
          >
            {loading ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

// Password Modal
export const PasswordModal = ({
  show,
  onClose,
  password
}) => {
  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Temporary Password</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          <p>Employee created successfully! Please share this temporary password:</p>
          <div className="password-display">
            <code>{password}</code>
            <button
              className="btn btn-sm"
              onClick={() => navigator.clipboard.writeText(password)}
            >
              Copy
            </button>
          </div>
          <p className="warning-text">
            This password will only be shown once. The employee should change it on first login.
          </p>
        </div>
        <div className="modal-footer">
          <button className="btn btn-primary" onClick={onClose}>Done</button>
        </div>
      </div>
    </div>
  );
};

// Reject Modal
export const RejectModal = ({
  show,
  onClose,
  reason,
  setReason,
  loading,
  onReject
}) => {
  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Reject Request</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label>Reason for Rejection</label>
            <textarea
              value={reason}
              onChange={e => setReason(e.target.value)}
              placeholder="Please provide a reason for rejecting this request..."
              rows={4}
            />
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button
            className="btn btn-danger"
            onClick={onReject}
            disabled={loading || !reason.trim()}
          >
            {loading ? 'Rejecting...' : 'Reject Request'}
          </button>
        </div>
      </div>
    </div>
  );
};

// Availability Modal
export const AvailabilityModal = ({
  show,
  onClose,
  data,
  loading
}) => {
  if (!show) return null;

  const dayOrder = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

  const formatTime = (timeStr) => {
    if (!timeStr) return '-';
    const parts = timeStr.split(':');
    const hour = parseInt(parts[0]);
    const period = hour >= 12 ? 'PM' : 'AM';
    const displayHour = hour === 0 ? 12 : (hour > 12 ? hour - 12 : hour);
    return `${displayHour} ${period}`;
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-large" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{data?.employee?.name}'s Availability</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          {loading ? (
            <div className="loading-state">Loading availability...</div>
          ) : !data?.availability ? (
            <div className="empty-state">
              <p>No availability set</p>
              <p className="hint-text">This employee hasn't submitted their availability yet.</p>
            </div>
          ) : (
            <div className="availability-display">
              <div className="availability-hours-summary">
                <div className="hours-stat">
                  <span className="stat-value">
                    {data.availability.weekly?.min_hours_per_week || 0} - {data.availability.weekly?.max_hours_per_week || 40}
                  </span>
                  <span className="stat-label">Preferred Hours/Week</span>
                </div>
              </div>

              {data.availability.weekly?.notes && (
                <div className="availability-notes">
                  <strong>Notes:</strong> {data.availability.weekly.notes}
                </div>
              )}

              <div className="availability-grid">
                <div className="availability-grid-header">
                  <span>Day</span>
                  <span>Status</span>
                  <span>Hours</span>
                </div>
                {dayOrder.map(day => {
                  const dayData = data.availability.weekly?.[day];
                  const isAvailable = dayData?.available;

                  return (
                    <div key={day} className={`availability-grid-row ${isAvailable ? 'available' : 'unavailable'}`}>
                      <span className="day-name">{day.charAt(0).toUpperCase() + day.slice(1)}</span>
                      <span className={`availability-badge ${isAvailable ? 'available' : 'unavailable'}`}>
                        {isAvailable ? 'Available' : 'Unavailable'}
                      </span>
                      <span className="time-range">
                        {isAvailable ? `${formatTime(dayData.start_time)} - ${formatTime(dayData.end_time)}` : '-'}
                      </span>
                    </div>
                  );
                })}
              </div>

              {data.availability.updated_at && (
                <div className="availability-updated">
                  Last updated: {new Date(data.availability.updated_at).toLocaleDateString()}
                </div>
              )}
            </div>
          )}
        </div>
        <div className="modal-footer">
          <button className="btn btn-primary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};
